import React, {Component} from 'react';
import './GeneralPopup.css';
import Popup from "../../components/popup/Popup";

export default class GeneralPopup extends Component{
	onClose = () => {
	   this.props.onClose();
	}
  render(){
    return(
    <Popup onClose={this.onClose} show className="g-general-popup">
			{this.props.content}
    </Popup>
    )
  }
}


// WEBPACK FOOTER //
// ./src/popups/generalPopup/GeneralPopup.jsx